import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('footer')(({ theme }) => ({
    textAlign: 'center',
    borderBottom: `8px solid ${theme.palette.primary.main}`,
    flexShrink: 0
}));

export const FooterInner = styled(Container)(() => ({
    paddingTop: 0,
    paddingBottom: '20px'
}));

export const FooterLogo = styled('a')(() => ({
    display: 'inline-block',
    maxWidth: '120px'
}));

export const FooterLogoImg = styled('img')(() => ({
    maxWidth: '100%'
}));

export const FooterCopyright = styled('p')(({ theme }) => ({
    margin: '0 0 10px',
    color: theme.palette.text.disabled,
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 500
}));